import { Player } from '@lottiefiles/react-lottie-player'
import classNames from 'classnames'
import { motion, useAnimate, type AnimationSequence } from 'framer-motion'
import { useEffect } from 'react'
import Marquee from 'react-fast-marquee'
import { useGlobalStore } from '../../../../store/global-store'
import type { NotifyRocketGameExploded } from '../../../../types/lives/notifies'

interface Props {
  toast: NotifyRocketGameExploded
}

// montar mensagem aqui
export function Toast({ toast }: Props) {
  const removeNotifyRocketGame = useGlobalStore((state) => {
    return state.removeNotifyRocketGame
  })

  const [scope, animate] = useAnimate()

  useEffect(() => {
    const sequence: AnimationSequence = [
      [scope.current, { x: 0 }, { duration: 2 }],
      [scope.current, { x: -window.innerWidth }, { delay: 5, duration: 2 }],
    ]

    if (toast?.id) {
      animate(sequence).then(() => {
        removeNotifyRocketGame(toast?.id as string)

        if ('ReactNativeWebView' in window) {
          // @ts-ignore
          window.ReactNativeWebView.postMessage('hide')
        }
      })
    }
  }, [toast, scope, animate, removeNotifyRocketGame])

  const hasTypeReward = 'typeReward' in toast

  const rocket = `https://storage.didderlive.com/games/rocket-game/b${toast?.rocketGameId ?? 1}.json`

  return (
    <motion.div
      ref={scope}
      className={classNames(
        'font-bold h-10 w-96 flex flex-row rounded-lg justify-center items-center px-2 border border-white gap-2 text-black',
        {
          'bg-linear-to-r from-[#4568DC] to-[#3B4781] text-white':
            hasTypeReward,
        },
      )}
      style={{
        x: window.innerWidth,
        ...('imgRocketGame' in toast && {
          backgroundColor: `${toast?.imgRocketGame}B3`,
        }),
      }}
    >
      {!hasTypeReward && (
        <Player
          loop
          autoplay
          src={rocket}
          className="w-10 h-10 left-0 scale-[2] -ml-2"
        />
      )}

      {hasTypeReward && (
        <img
          src={toast?.imgUser}
          className="w-8 h-8 bg-black rounded-full border"
        />
      )}

      <div className="min-w-0 w-full flex justify-start">
        <Marquee delay={1} speed={80} style={{ width: '80%' }}>
          {toast?.message}
        </Marquee>
      </div>

      {hasTypeReward && (
        <img
          src={(toast?.imgGiftFrame || toast?.imgGift) ?? toast?.imgItem}
          className="w-20 h-20 -mr-8"
        />
      )}
    </motion.div>
  )
}
